import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { getSrcSetData } from './imgUrls'
import GridImage from './gridImage'
import FavoriteButton from '../../buttons/favoriteButton/favoriteButton'
import itemAspectRatio from '../../../../common/utils/itemAspectRatio'
import formatPrice from '../../../../common/utils/formatPrice'

import styles from './index.module.css'

class PhotoduneGridItemCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = { focused: false }
    this.onItemClick = this.onItemClick.bind(this)
  }

  onItemClick = event => {
    const { selectItem, item } = this.props
    event.preventDefault()
    selectItem(item)
  }

  enableFocus = () => this.setState({ focused: true })
  disableFocus = () => this.setState({ focused: false })

  render() {
    const { item, rank, onAddToFavourites, imageClassName } = this.props
    const aspectRatio = itemAspectRatio(item) || 1.0

    const imgSrcs = getSrcSetData(item.image_urls, 'w400', aspectRatio)
    const paddingTop = `${100 / aspectRatio}%`

    const classes = classnames(styles.itemCard, {
      [styles.itemCardActive]: this.state.focused
    })

    const favouriteButtonClasses = classnames(styles.favouriteButton, {
      [styles.favouriteButtonActive]: item.ui.isInFavourites
    })

    return (
      <div
        className={styles.itemCardWrapper}
        onFocus={this.enableFocus}
        onBlur={this.disableFocus}
        onMouseLeave={this.disableFocus}
      >
        <a className={classes} href={`${item.url}?s_rank=${rank}`}>
          <div className={styles.imageWrapper} style={{ paddingTop }}>
            <GridImage
              imgSrcs={imgSrcs}
              imageClassName={imageClassName}
              alt={item.name}
            />
          </div>
          <div className={styles.itemInnerContainer}>
            <div className={styles.price}>${formatPrice(item.price_cents)}</div>
          </div>
          <div
            className={styles.hiddenClickableImageWrapper}
            onClick={this.onItemClick}
          >
            <GridImage
              imgSrcs={imgSrcs}
              imageClassName={styles.hiddenClickableImage}
              alt={item.name}
            />
          </div>
        </a>
        <div className={styles.itemActions}>
          <FavoriteButton
            itemId={item.id}
            onClick={onAddToFavourites}
            isActive={item.ui.isInFavourites}
            className={favouriteButtonClasses}
          />
        </div>
        <div className={styles.itemInfo}>
          <p className={styles.itemName}>{item.name}</p>
          <p className={styles.userNameWrapper}>
            <em>by</em>{' '}
            <a href={item.author_url} className={styles.userName}>
              {item.author_username}
            </a>
          </p>
        </div>
      </div>
    )
  }
}

PhotoduneGridItemCard.propTypes = {
  item: PropTypes.object.isRequired,
  rank: PropTypes.number.isRequired
}

export default PhotoduneGridItemCard
